import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthConfig, AuthService, proBySourceEnum } from '../../../Services/auth.service';
import { NotificationsService } from '../../../Services/shared/notifications.service';
import { Artist, ArtistArtType, ArtistsService } from '../../../Services/artists.service';
import { NotificationTypes } from '../../../app.enums';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CloudinaryImageService } from 'src/app/Services/cloudinary-image.service';
import { ArtTypeService } from 'src/app/Services/art-type.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { SubscriptionRules } from 'src/app/models/subscriptionrules.model';
import { FileUpload } from 'primeng/fileupload';
import { ImageCroppedResponse } from 'src/app/common/image-cropper/image-cropper.component';
import { UsersService } from 'src/app/Services/users.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-artists',
    templateUrl: './artists.component.html',
    styleUrls: ['./artists.component.css'],
    providers: [ArtTypeService],
    standalone: false
})
export class ArtistsComponent implements OnInit {
  @ViewChild('additionalFileUploadCmp') additionalFileUploadCmp!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('buissnesslogo') buissnesslogo!: FileUpload;
  public enableCropper: boolean = true;
  public currentSelectedImageToCrop?: File | null;
  public showCropperDialog: boolean = false;
  public additionalFiles: any[] = [];
  public selectedFile: File | null = null;
  public isEditMode: boolean = false;
  public artistsLoading = true;
  public artists: Artist[] = [];
  public artTypes: SelectItem[] = [];
  public selectedArtTypes: SelectItem[] = [];
  public isArtist: boolean = false;
  public authConfig: AuthConfig = {};
  public formData: Artist = {} as Artist;
  public artistDialogvisible = false;
  public upgradeDialogVisible = false;
  public filterByArtflow: boolean = false;
  public filterByFreeTrial: boolean = false;
  public filterByStripe: boolean = false;
  public filterByAppleInAppPurchase: boolean = false
  public uploader!: FormGroup;
  artistId: string | null = null; // or whatever the initial value should be
  public selectedTabIndex: number = 0; // Initialize with the index of the first tab
  public activeSubscriptionRule!: SubscriptionRules;
  public subscriptionRules: SelectItem[] = [];
  public recordCount: number = 15;
  public dropDownData: SelectItem[] = [];
  public proBySource:any = proBySourceEnum;
  
  recordOptions = [
    { label: '15 records per page', value: 15 },
    { label: '25 records per page', value: 25 },
    { label: '50 records per page', value: 50 },
    { label: '500 records per page', value: 500 },
  ];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private ArtTypeService: ArtTypeService,
    private confirmationService: ConfirmationService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private uploadService: CloudinaryImageService,
    private fb: FormBuilder,
    private artistService: ArtistsService,
    private userService: UsersService,
    private subscriptionRulesService: SubscriptionRulesService,
    private transloco: TranslocoService
  ) {
    this.formData = new Artist();
    this.uploader = this.fb.group({
      file: [null],
    });
  }

  updateRecordCount(value: number) {
    this.recordCount = value;
    localStorage.setItem('recordCount', this.recordCount.toString());
    console.log('Records per page:', this.recordCount);
  }
  ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
      this.getAllArtists();
      this.getArtTypes();


    }

    this.selectedTabIndex = 0;
    this.getSubscriptionRuleSetsDropdown();
  }

  public getSubscriptionRuleSetsDropdown() {
    this.ngxSpinnerService.show();
    this.subscriptionRulesService.fetchRuleSetsDropdown().subscribe((ActiveSubscriptionRule: SelectItem[]) => {
      this.subscriptionRules = ActiveSubscriptionRule
      console.log(this.subscriptionRules)
      // if (this.subscriptionRules.length > 0) {
      //   // const lastSubscriptionRule = this.subscriptionRules[this.subscriptionRules.length - 1];
      //   const firstSubscriptionRule = this.subscriptionRules[0];
      //   this.formData.SubscriptionRuleSetId = firstSubscriptionRule.value; // Assuming `value` is the ID or key of the rule set
      // }
      this.ngxSpinnerService.hide()
    }, (error) => { console.error('Error while fetching subscription rules data', error); this.ngxSpinnerService.hide(); })
  }



  private getAllArtists() {
    this.ngxSpinnerService.show();
    this.artistService.getAllArtist().subscribe(
      (artists) => {
        this.artists = artists;
        console.log('artists', this.artists);
        this.artistsLoading = false;
        this.ngxSpinnerService.hide();
      },
      (error) => {
        this.handleRequestError(error);
      }
    );
  }

  private saveArtist() {
    this.ngxSpinnerService.show();
    this.formData.ImgUrl = this.formData.ImgUrl;
    console.log('this.formData', this.formData);
    this.artistService.saveArtist(this.formData).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(
            this.transloco.translate('artists.successTitle'),
            response.ResponseMessage,
            NotificationTypes.Success
          );
          this.getAllArtists();
          this.artistDialogvisible = false;
          this.selectedTabIndex = 0;
        } else {
          this.notificationsService.showNotification(
            this.transloco.translate('artists.errorTitle'),
            response.ResponseMessage,
            NotificationTypes.Error
          );
        }
      },
      (error) => {
        this.handleRequestError(error);
      }
    );
  }

  public moveToArtistProduct(artistId: string) {
    this.router.navigate(['/artists', artistId, 'artworks']);
  }

  public onArtTypesChange(event: any): void {
    this.formData.ArtistArtTypes = event.value.map((p: { value: any; }) => p.value);

  }



  filterByName(event: Event, dt: any) {
    const inputValue = (event.target as HTMLInputElement)?.value;
    dt.filter(inputValue, 'name', 'contains');
  }

  showDialog() {
    this.artistDialogvisible = true;
    this.isEditMode = false;
    this.selectedTabIndex = 0;
  }

  public closeDialog(): void {
    this.artistDialogvisible = false;
    // Reset the form when the dialog is closed
    this.formData = {} as Artist;
    this.selectedArtTypes = [];
    this.selectedTabIndex = 0;
  }

  submitForm() {
    console.log('Form submitted!', this.formData);
    this.saveArtist();
  }

  public deleteArtist(Id: string) {
    this.confirmationService.confirm({
      accept: () => {
        this.ngxSpinnerService.show();
        this.artistService.deleteArtist(Id).subscribe(
          (response) => {
            this.ngxSpinnerService.hide();
            if (response.Success) {
              this.notificationsService.showNotification(
                this.transloco.translate('artists.successTitle'),
                response.ResponseMessage,
                NotificationTypes.Success
              );
              var index = this.artists.findIndex((artist) => artist.Id == Id);
              if (index >= 0) {
                this.artists.splice(index, 1);
              }
            } else {
              this.notificationsService.showNotification(
                this.transloco.translate('artists.errorTitle'),
                response.ResponseMessage,
                NotificationTypes.Error
              );
            }
          },
          (error) => {
            this.handleRequestError(error);
          }
        );
      },
    });
  }

  public editArtist(id: string) {
    const currentArtist = this.artists.find((p) => p.Id == id);
    console.log(currentArtist);
    if (currentArtist) {
      this.formData = { ...currentArtist };

      // Set selectedArtTypes based on ArtistArtTypes
      this.selectedArtTypes = currentArtist.ArtistArtTypes.map((artType) => ({
        label: artType.ArtTypeLabel,
        value: artType.ArtTypeId, // Set this based on your requirements
      }));

      this.formData.ArtistArtTypes = this.selectedArtTypes.map((p: { value: any }) => p.value);
      this.isEditMode = true;
      this.artistDialogvisible = true;
      // Check subscription type based on SubscriptionRuleSetId

    }

    this.selectedTabIndex = 0;
  }

  private handleRequestError(error: any) {
    this.artistsLoading = false;
    console.error(error);
    this.ngxSpinnerService.hide();
  }



  public imgType: string = '';


 // File Selection Handler
public onFileSelected(files: File[], imgType: string) {
  console.log(files);
  if(files.length > 0){
    this.selectedFile = files[0]; // Get the selected file
    console.log(this.selectedFile);

    // Check if the selected file is an image
    const isImage = this.selectedFile && this.selectedFile.type.includes('image');
    if (isImage) {
        this.imgType = imgType; // Store the image type (ArtistImg or BusinessLogo)
        this.showCropperDialog = true; // Show cropper dialog
        this.currentSelectedImageToCrop = this.selectedFile; // Set the image to crop
    } else {
        console.log('Selected file is not an image');
    }
  }
}

// Cropped Image Handler
public onImageCropped(croppedImage: ImageCroppedResponse) {
  console.log(croppedImage);
  // Set the cropped image as the selected file
  this.selectedFile = croppedImage.CroppedImage;

  // Now upload the cropped image
  this.uploadImage(this.imgType);
  
  // Close the cropper dialog
  this.showCropperDialog = false;
}

// Image Upload Logic
public uploadImage(value: string) {
  if (this.selectedFile) {
      const formData = new FormData();
      formData.append('ImageFile', this.selectedFile);
      // Upload the cropped image based on the value (ArtistImg or BusinessLogo)
      if (value == 'ArtistImg') {
          this.uploadService.uploadImage(formData).subscribe((res: any) => {
              this.formData.ImgUrl = res;
          });
      } else if (value == 'BusinessLogo') {
          this.uploadService.uploadImage(formData).subscribe((res: any) => {
              this.formData.BusinessLogoUrl = res;
          });
      }
  } else {
      console.log('No image to upload.');
  }
}

// Remove Image Logic
public removeImg(value: string) {
  if (value == 'ArtistImg') {
      this.formData.ImgUrl = null!;
  } else if (value == 'BusinessLogo') {
      this.formData.BusinessLogoUrl = null!;
  }
}

public onImageCropperClose($event: any) {
  console.log('Dialog close event:', $event);
  if ($event.skipCropping == true) {
    this.selectedFile = null;
    this.currentSelectedImageToCrop = null;
    this.showCropperDialog = false;
    console.log('this.selectedFile', this.selectedFile);
    console.log('this.currentSelectedImageToCrop', this.currentSelectedImageToCrop);
    if(this.fileUpload){
      this.fileUpload.clear();
    }
    if(this.buissnesslogo){
      this.buissnesslogo.clear();
    }
      // Handle skipping cropping if needed
  }
}







  private getArtTypes() {
    var filterRoleBasedArttypes = false;
    this.artTypes = [];
    this.ArtTypeService.fetch(filterRoleBasedArttypes).subscribe(
      (artTypeItems) => {
        this.artTypes = artTypeItems.map((item) => {
          return { label: item.Name, value: item.Id };
        });
        console.log('ArtTypes: ', this.artTypes);
      },
      (error) => {
        console.error(error);
      }
    );
  }
  handleDialogClose(event: any) {
    this.upgradeDialogVisible = false;
  }



  public switchAccount(rowData: Artist): void {
    this.ngxSpinnerService.show();
    this.authService.switchAccount(rowData.Id || '').subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          // Check if artist is event-only - try multiple sources for reliability
          const galleryEventIdFromToken = this.authService.getGalleryEventIdFromToken();
          const galleryEventIdFromResponse = response.ResponseData?.AuthUser?.GalleryEventId;
          const galleryEventIdFromRowData = rowData.GalleryEventId;

          // Use any available source to determine if event artist
          const isEventArtist = !!(galleryEventIdFromToken || galleryEventIdFromResponse || galleryEventIdFromRowData);

          console.log('Switch account debug:', {
            fromToken: galleryEventIdFromToken,
            fromResponse: galleryEventIdFromResponse,
            fromRowData: galleryEventIdFromRowData,
            isEventArtist: isEventArtist
          });

          const redirectPath = isEventArtist ? '/dashboard' : '/ds-dashboard';
          this.router.navigate([redirectPath]).then(() => {
            location.reload();
          });
          return;
        }
        this.notificationsService.showNotification(this.transloco.translate('artists.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }



  public switchToProAccount(Id: string,setPro: boolean){
    console.log(Id)
    this.ngxSpinnerService.show();
    this.userService.proAnyUserByPlateformUser(Id,setPro).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('artists.successTitle'), response.ResponseMessage, NotificationTypes.Success);
          this.getAllArtists();
        }
        else{
          this.notificationsService.showNotification(this.transloco.translate('artists.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.notificationsService.showNotification(this.transloco.translate('artists.errorTitle'), error, NotificationTypes.Error);
        this.ngxSpinnerService.hide();
      }
    );
  }
 
  public getFilteredArtist() {
    // this.ngxSpinnerService.show();
    // this.artistService.getAllArtist().subscribe((artist) => {
    //   this.artists = artist;
      
    //   this.ngxSpinnerService.hide();
    // }, (error) => {
    //   console.error(error); this.ngxSpinnerService.hide();
    //   // this.galleryProductsLoaded = true;
    // });
    if (this.filterByArtflow) {
        this.artists = this.artists.filter(artist => artist.ProBySource == this.proBySource.Artflow);
      }
      else if (this.filterByFreeTrial) {
        this.artists = this.artists.filter(artist => artist.ProBySource == this.proBySource.FreeTrial);

      }
      else if (this.filterByStripe) {
        this.artists = this.artists.filter(artist => artist.ProBySource == this.proBySource.Stripe);
      }
      else if (this.filterByAppleInAppPurchase) {
        this.artists = this.artists.filter(artist => artist.ProBySource == this.proBySource.AppleInAppPurchase);
      }else{
        this.getAllArtists();
      }
      console.log('Filtered artists', this.artists);
  }

}
